<template>
  <div class='home'>
    <WarehouseList
      v-show='listView'
      @newWarehouse='onClickNewFromList'
      @editWarehouse='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <WarehouseForm
      v-show='formView'
      :warehouse='warehouse'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import WarehouseList from '@/components/warehouse/WarehouseList.vue'
import WarehouseForm from '@/components/warehouse/WarehouseForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'Warehouse',
  components: {
    WarehouseList,
    WarehouseForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      warehouse: {
        id: null,
        warehouse_no: null,
        name: null,
        address: null,
        phone: null,
        branch_no: null,
        company_no: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.warehouse = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.warehouse = {
        id: null,
        warehouse_no: null,
        name: null,
        address: null,
        phone: null,
        branch_no: null,
        company_no: this.authUser.company_no
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.warehouse = {
        id: null,
        warehouse_no: null,
        name: null,
        address: null,
        phone: null,
        branch_no: null,
        company_no: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  mounted () {
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
